'use client'

import type { LabelButtonProps } from '@pearlconvert/ui/components/button/button.types'

import classNames from 'classnames'
import React from 'react'

const SwatchButton: React.FC<LabelButtonProps> = ({
  children,
  title,
  size,
  isLoading = false,
  disabled,
  inactive,
  className,
  onClick,
  testId,
}: LabelButtonProps) => {
  const buttonClass = classNames('button', 'button__swatch', {
    [`button__swatch--${size}`]: size,
    button__loading: isLoading,
    [`button__${className}`]: className,
  })

  return (
    <button
      title={title}
      className={buttonClass}
      disabled={disabled}
      aria-disabled={disabled || inactive}
      aria-label={title}
      data-testid={testId}
      onClick={(event) => onClick?.(event)}
    >
      <span className="button__text">{children}</span>
    </button>
  )
}

export default SwatchButton
